module.exports = __webpack_public_path__ + "img/xbox-black.f2cfcd16.png";